/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

//calSlice
import { createSlice } from '@reduxjs/toolkit';

export const calSlice = createSlice({
  name: "cal",
  initialState: {
    modalStatus: false,
    selectedCal: null
  },
  reducers: {
    openAddCalModal: (state) => {
      state.modalStatus = "add";
    },
    openEditCalModal: (state, action) => {
      state.modalStatus = "edit";
      state.selectedCal = action.payload;
    },
    openDeleteCalModal: (state, action) => {
      state.modalStatus = "delete";
      state.selectedCal = action.payload;
    },
    closeCalModal: (state) => {
      state.modalStatus = false;
      state.selectedCal = null;
    }
  }
});

export const {
  openAddCalModal,
  openEditCalModal,
  openDeleteCalModal,
  closeCalModal
} = calSlice.actions;

export default calSlice.reducer;